module.exports = __webpack_public_path__ + "static/media/MattMiller.cb759181.JPG";